const settings = {
  settings: {
    transOil: {
      screens: [
        {
          title: 'x-label:workflow1.settings.hydraulic trans oil.hydraulic trans oil',
          data: [
            {
              label: 'x-label:workflow1.settings.hydraulic trans oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow1.settings.hydraulic trans oil.hrs',
              num: '250.0',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow1.settings.hydraulic trans oil.screen2.hydraulic trans oil',
          data: [
            {
              label: 'x-label:workflow1.settings.hydraulic trans oil.screen2.use exmark premium transmission oil?',
              center: true,
              shrinkContent: true
            }
          ]
        },
        {
          title: 'x-label:workflow1.settings.hydraulic trans oil.screen3.reset trans oil maint hours',
          data: [
            {
              label: 'x-label:workflow1.settings.hydraulic trans oil.screen3.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/exit',
        right: 'settings/engine-oil'
      }
    },
    engineOil: {
      screens: [
        {
          title: 'x-label:workflow1.settings.engine oil.engine oil',
          data: [
            {
              label: 'x-label:workflow1.settings.engine oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow1.settings.engine oil.hrs',
              num: '5.0',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow1.settings.engine oil.screen2.reset engine oil maint hours',
          data: [
            {
              label: 'x-label:workflow1.settings.engine oil.screen2.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/hydraulic-trans-oil',
        right: 'settings/historical-error'
      }
    },
    historicalError: {
      screens: [
        {
          title: 'x-label:workflow1.settings.historical error.historical error',
          data: [
            {
              label: 'x-label:workflow1.settings.historical error.eng limp mode active',
              center: true
            },
            {
              label: 'x-label:workflow1.settings.historical error.x',
              num: '1',
              center: true
            },
            {
              label: 'x-label:workflow1.settings.historical error.hrs',
              num: '196.4',
              center: true
            }
          ]
        }
      ],
      routes: {
        left: 'settings/engine-oil',
        right: 'settings/alarms'
      }
    },
    alarms: {
      screens: [
        {
          title: 'x-label:workflow1.settings.alarms.alarms',
          data: [
            {
              label: 'x-label:workflow1.settings.alarms.activate/deactivate',
            },
            {
              label: 'x-label:workflow1.settings.alarms.audible alarms',
            }
          ]
        }
      ],
      list: [
        {
          name: 'x-label:workflow1.settings.alarms.service engine oil',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.service trans oil',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.fuel low',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.system over voltage > 16v',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.system voltage low',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.system under voltage < 9v',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.clutch over current',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.clutch reset required',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.engine errors',
          active: true
        },
        {
          name: 'x-label:workflow1.settings.alarms.power up check',
          active: true
        }
      ],
      routes: {
        left: 'settings/historical-error',
        right: 'settings/engine-settings'
      }
    },
    engineSettings: {
      screens: [
        {
          title: 'x-label:workflow1.settings.engine settings.engine settings',
          data: [
            {
              label: 'x-label:workflow1.settings.engine settings.adjust engine speeds',
            }
          ]
        }
      ],
      list: [
        {
          name: 'lowMow',
          label: 'x-label:workflow1.settings.engine settings.set low mow speed',
          min: 2250,
          max: 3400,
          value: 2250
        },
        {
          name: 'effMow',
          label: 'x-label:workflow1.settings.engine settings.set eff mow speed',
          min: 3100,
          max: 3650,
          value: 3100
        },
        {
          name: 'maxMow',
          label: 'x-label:workflow1.settings.engine settings.set max mow speed',
          min: 3300,
          max: 3650,
          value: 3300
        },
        {
          name: 'effTrans',
          label: 'x-label:workflow1.settings.engine settings.set eff transport speed',
          min: 2200,
          max: 2800,
          value: 2250
        },
        {
          name: 'maxTrans',
          label: 'x-label:workflow1.settings.engine settings.set max transport speed',
          min: 3300,
          max: 3650,
          value: 3300
        }
      ],
      routes: {
        left: 'settings/alarms',
        right: 'settings/calibrate-engine-speed'
      }
    },
    calibrateEngineSpeed: {
      screens: [
        {
          title: 'x-label:workflow1.settings.calibrate engine speed.calibrate engine speed',
          data: [
            {
              label: 'x-label:workflow1.settings.calibrate engine speed.start calibration',
            },
            {
              label: 'x-label:workflow1.settings.calibrate engine speed.calibrating',
            },
            {
              label: 'x-label:workflow1.settings.calibrate engine speed.calibration complete',
            }
          ]
        }
      ],
      routes: {
        left: 'settings/engine-settings',
        right: 'settings/factory-defaults'
      }
    },
    factoryDefaults: {
      screens: [
        {
          title: 'x-label:workflow1.settings.factory defaults.factory defaults',
          data: [
            {
              label: 'x-label:workflow1.settings.engine oil.reset',
            },
          ]
        },
        {
          title: 'x-label:workflow1.settings.factory defaults.screen2.factory defaults',
          data: [
            {
              label: 'x-label:workflow1.settings.factory defaults.screen2.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/calibrate-engine-speed',
        right: 'settings/exit'
      }
    },
    exit: {
      title: 'x-label:workflow1.settings.exit.exit',
      routes: {
        left: 'settings/factory-defaults',
        right: 'settings/hydraulic-trans-oil'
      }
    }
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/screens/data/flow1/settings.js